import request from '@/config/axios'

// 岗位工作流步骤
export interface AiJobStepVO {
  key: string
  title: string
  instruction: string
  riskLevel: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'
  toolName?: string
  employeeId?: number
  waitUserInput?: boolean
  userInputTemplate?: string
  templateUrl?: string
}

// 岗位数字人定义（运行态）
export interface AiJobVO {
  code: string
  name: string
  description: string
  systemPrompt: string
  steps: AiJobStepVO[]
  allowedToolNames: string[]
  forbiddenActions: string[]
  clientConfig?: Record<string, any>
}

// 岗位步骤（配置态）
export interface AiJobStepSaveVO {
  stepKey: string
  stepTitle: string
  instruction?: string
  riskLevel: 'LOW' | 'MEDIUM' | 'HIGH' | 'CRITICAL'
  toolName?: string
  employeeId?: number
  waitUserInput?: boolean
  userInputTemplate?: string
  templateUrl?: string
}

// 岗位数字人（配置态）
export interface AiJobPositionVO {
  id?: number
  positionCode: string
  positionName: string
  description?: string
  systemPrompt?: string
  allowedToolNames?: string[]
  forbiddenActions?: string[]
  clientConfig?: Record<string, any>
  steps: AiJobStepSaveVO[]
  status?: number
  sort?: number
  remark?: string
}

// 岗位数字人 API
export const JobApi = {
  // 岗位列表（运行态定义）
  list: async (): Promise<AiJobVO[]> => request.get({ url: '/ai/job/list' }),
  // 岗位配置列表（含步骤，用于管理页编辑）
  configList: async (): Promise<AiJobPositionVO[]> => request.get({ url: '/ai/job/config-list' }),
  // 获得岗位配置
  get: async (id: number): Promise<AiJobPositionVO> => request.get({ url: `/ai/job/get?id=${id}` }),
  // 创建岗位
  create: async (data: AiJobPositionVO) => request.post({ url: '/ai/job/create', data }),
  // 更新岗位
  update: async (data: AiJobPositionVO) => request.put({ url: '/ai/job/update', data }),
  // 删除岗位
  delete: async (id: number) => request.delete({ url: `/ai/job/delete?id=${id}` }),
  // 运行岗位 Graph 工作流（聊天/预览）
  chat: async (positionCode: string, task: string) =>
    request.post({ url: '/ai/job/chat', data: { positionCode, task } })
}
